module.exports = "../dist/img/loading.0574.gif";